import { useEffect } from "react";
import style from "./aside.module.scss";
import { NavLink, useLocation } from "react-router-dom";

declare const KTScroll: any;

function RootAside() {

  const { pathname } = useLocation()

  useEffect(() => {
    const scrollElement = document.querySelector("#kt_aside_menu_wrapper");
    const scroll = KTScroll.getInstance(scrollElement);

    if (scroll) {
      setTimeout(() => scroll.update(), 100);
    }
  }, []);

  return (
    <div
      className={"aside aside-default aside-hoverable " + style.Aside}
      data-kt-drawer="true"
      data-kt-drawer-activate="{default: true, lg: false}"
      data-kt-drawer-direction="start"
      data-kt-drawer-name="aside"
      data-kt-drawer-overlay="true"
      data-kt-drawer-toggle="#kt_aside_toggle"
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      id="kt_aside"
    >
      <div
        className="aside-logo flex-column-auto px-10 pt-9 pb-5"
        id="kt_aside_logo"
      >
        <a href="index.html">
          <img
            alt="Logo"
            className="max-h-50px logo-default theme-light-show lz"
            src="/assets/media/logos/logo-default.svg"
          />
          <img
            alt="Logo"
            className="max-h-50px logo-default theme-dark-show"
            src="/assets/media/logos/logo-default-dark.svg"
          />
          {/* <img
            alt="Logo"
            className="max-h-50px logo-minimize"
            src="/assets/media/logos/logo-minimize.svg"
          /> */}
        </a>
      </div>
      <div className="aside-menu flex-column-fluid ps-3 pe-1">
        <div
          className="menu menu-sub-indention menu-column menu-rounded menu-title-gray-600 menu-icon-gray-500 menu-active-bg menu-state-primary menu-arrow-gray-500 fw-semibold fs-6 my-5 mt-lg-2 mb-lg-0"
          data-kt-menu="true"
          id="kt_aside_menu"
        >
          <div
            className="hover-scroll-y mx-4"
            data-kt-scroll="true"
            data-kt-scroll-activate="{default: false, lg: true}"
            data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
            data-kt-scroll-height="auto"
            data-kt-scroll-offset="20px"
            data-kt-scroll-wrappers="#kt_aside_menu"
            id="kt_aside_menu_wrapper"
          >
            <div className="menu-item pt-5">
              <div className="menu-content">
                <span className="fw-bold text-muted text-uppercase fs-7">
                  Administración
                </span>
              </div>
            </div>
            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/balance"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-setting-2 fs-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </i>
                </span>
                <span className="menu-title">Cuentas</span>
              </NavLink>
            </div>
        
          </div>
        </div>
      </div>
    </div>
  );
}

export default RootAside;
